import styled from 'styled-components';

export const Field = styled.div`
  display: block;
  margin-bottom: 24px;
  width: ${({ width }) => (width ? `${width}px` : '100%')};

  & > div {
    width: 100%;
  }
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.gray};
  display: block;
  width: 100%;
  text-align: left;
  margin-bottom: 12px;
`;

export const FloatContainer = styled.div`
  background: ${({ theme }) => theme.inputBackground};
  border-radius: 4px;
  border: none;
  color: ${({ theme }) => theme.grayDark};
  display: block;
  padding: 16px;
  height: 55px;
  width: 100%;
`;

Field.defaultProps = {
  'data-id': 'Field',
};

Label.defaultProps = {
  'data-id': 'Label',
};

FloatContainer.defaultProps = {
  'data-id': 'FloatContainer',
};
